import { ReactNode } from "react";
import styles from "@/pages/index.module.css";

export function About(): ReactNode {
  return (
    <div className={styles.aboutContainer}>
      <a href="mailto:claire@doodly-coo.fun" aria-label="DoodlyCoo, a daily drawing game by Claire">
        <svg viewBox="0 0 100 100">
          <path fill="none" id="circle" d="M 10, 50 a 40,40 0 1,1 80,0 40,40 0 1,1 -80,0" />
          <text textLength={Math.floor(Math.PI * 2 * 40)}>
            <textPath textLength={Math.floor(Math.PI * 2 * 40)} xlinkHref="#circle">
              &nbsp; DoodlyCoo ● A daily drawing game ● by Claire ●
            </textPath>
          </text>
        </svg>
      </a>
    </div>
  );
}
